import { lazier } from '@shared/components';

export const UnapproveAdvancementModal = lazier(
  () => import('./UnapproveAdvancementModal'),
  false,
);

export { default as UnapproveAdvancementButton } from './UnapproveAdvancementButton';
